import {
    Container
} from "@dropDesk/presentation/pages/subscription/ui/select_plan/confirm_plan/body/styled";
import React from "react";
import {PlanEntity} from "@dropDesk/domain/entities/plan/plan_entity";
import DividerDropDesk from "src/presentation/components/divider";
import Inputs from "@dropDesk/presentation/pages/subscription/ui/select_plan/confirm_plan/body/inputs";
import Advantage from "@dropDesk/presentation/pages/subscription/ui/select_plan/confirm_plan/body/advantage";
import {PaymentSubscriptionEntity} from "@dropDesk/domain/entities/payment_subscriptions/payment_subscription_entity";
import CurrentSubscription
    from "@dropDesk/presentation/pages/subscription/ui/select_plan/confirm_plan/body/current_subscription";
import CurrentExtensions
    from "@dropDesk/presentation/pages/subscription/ui/select_plan/confirm_plan/body/current_extensions";
import {CompanyExtensionEntity} from "@dropDesk/domain/entities/plan_extensions/company_extension.entity";
import NotIncludedFeatures
    from "@dropDesk/presentation/pages/subscription/ui/select_plan/confirm_plan/body/not_included";


const Body = (
    {
        currentSubscription,
        newSubscription,
        handleAllChanges,
        hasDowngrade,
        isLegacy,
        plans,
        installedExtensions,
        contractedExtensionSlugs
    }: {
        currentSubscription: PaymentSubscriptionEntity
        newSubscription: PaymentSubscriptionEntity
        handleAllChanges: (event: {
            target: {
                name: string;
                value: any;
                checked: any;
                type: string
            }
        }) => void
        hasDowngrade: boolean
        isLegacy: boolean
        plans: PlanEntity[]
        installedExtensions: CompanyExtensionEntity[]
        contractedExtensionSlugs: string[]
    }
) => {

    return (
        <Container>
            <Inputs
                newSubscription={newSubscription}
                handleAllChanges={handleAllChanges}
                hasDowngrade={hasDowngrade}
                plans={plans}
                isLegacy={isLegacy}
            />
            {!currentSubscription.plan.isFreePlan && <> <DividerDropDesk/>
                <CurrentSubscription currentSubscription={currentSubscription}/>
            </>}
            {installedExtensions.length > 0 && <> <DividerDropDesk/>
                <CurrentExtensions installedExtensions={installedExtensions}/>
            </>}
            <DividerDropDesk/>
            <Advantage/>
            <NotIncludedFeatures contractedExtensionSlugs={contractedExtensionSlugs}/>
        </Container>
    );
}
export default Body;
